import React from 'react';
import { createStructuredSelector } from 'reselect';
import { useDispatch, useSelector } from 'react-redux';
import { FiTrash } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';
import { useInjectReducer } from 'utils/injectReducer';
import reducer from './reducer';
import { RootState } from './types';
import { Shelf } from '../../../lib/modelBuilder/entities/Shelf';
import { makeSelectShelvesSelected } from '../../Configurator/selectors/selection';
import { makeSelectShelves } from '../../Configurator/selectors/furniture';
import { removeShelfRequest } from '../../Configurator/actions/furniture';
import { selectRecentModifiedShelf } from './selectors';
import { addRecentModified } from './actions';
import { shelvesSelectionAction } from '../../Configurator/actions/selection';

interface StateProps {
  shelvesSelected: Shelf[];
  shelvesCabinet: Shelf[];
  recentModifiedShelf?: Shelf;
}

const stateSelector = createStructuredSelector<RootState, StateProps>({
  shelvesSelected: makeSelectShelvesSelected(),
  shelvesCabinet: makeSelectShelves(),
  recentModifiedShelf: selectRecentModifiedShelf(),
});

const RemoveShelfButton = () => {
  useInjectReducer({ key: 'removeShelfButton', reducer: reducer });
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { shelvesSelected, shelvesCabinet, recentModifiedShelf } = useSelector(
    stateSelector,
  );

  let shelf: Shelf | undefined = undefined;
  if (shelvesCabinet.length > 1) {
    if (shelvesSelected.length === 1) {
      shelf = shelvesSelected[0];
    } else if (recentModifiedShelf !== undefined) {
      shelf = recentModifiedShelf;
    }
  }

  if (shelf !== undefined) {
    return (
      <button
        onClick={() => {
          if (shelf !== undefined) {
            dispatch(removeShelfRequest(shelf.level));
            dispatch(shelvesSelectionAction([Math.max(shelf.level - 1, 0)]));
            dispatch(addRecentModified(undefined));
          }
        }}
        className="flex flex-col justify-center items-center mb-2"
        onMouseEnter={() => {
          if (recentModifiedShelf)
            dispatch(shelvesSelectionAction([recentModifiedShelf.level]));
        }}
        onMouseLeave={() => {
          if (recentModifiedShelf) dispatch(shelvesSelectionAction([]));
        }}
      >
        <FiTrash className="h-8 w-8 text-red-dark" />
        <div className="text-sm">{t('Remove this shelf')}</div>
      </button>
    );
  } else return null;
};

export default RemoveShelfButton;
